export enum CourseContentMenuType {
    week = 1,
    weekAndActivity = 2,
    unit = 3,
    weekAndActivityStory =4
}